export default {
  table: {
    columns: {
      actions: "Actions",
    },
    values: {
      noColor: "No color",
    },
  },
};
